import { render, staticRenderFns } from "./GradeCourseFilter.vue?vue&type=template&id=ff508962"
import script from "./GradeCourseFilter.vue?vue&type=script&lang=js"
export * from "./GradeCourseFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports